import { inject, Service } from '@angular/core';
import { EventBusService } from '@shared';
import { FooterConfigurationToFooter, ORDER_FORM_FOOTER_EVENTS } from './order-form-footer-events.model';

/**
 * Order Form → Footer configuration producer.
 */
@Service({ autoProvided: false })
export class OrderFormFooterEventProducerService {
	private readonly eventBus = inject(EventBusService);

	publishFooterConfiguration(config?: FooterConfigurationToFooter): void {
		this.eventBus.dispatch(ORDER_FORM_FOOTER_EVENTS.FOOTER_CONFIGURATION, config);
	}

	configureOrderFormFooter(): void {
		this.publishFooterConfiguration({ visible: false });
	}

	resetFooter(): void {
		this.publishFooterConfiguration();
	}
}
